import { NavBarBackButton } from '@/design-system';
import styles from './Help.styles';

export const Help: React.FC = () => {
  return (
    <>
      <NavBarBackButton trackId="helpPage">Help</NavBarBackButton>
    </>
  );
};
